import { render, staticRenderFns } from "./PlannedMeasureProvider.vue?vue&type=template&id=b8ca103a&scoped=true&"
import script from "./PlannedMeasureProvider.vue?vue&type=script&lang=ts&"
export * from "./PlannedMeasureProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca103a",
  null
  
)

export default component.exports